import { API_URLs } from "../../../utilities/API_URLs"
import iAxios from "../../../utilities/axios/axios-setup"
import { UserUpdateRequest } from "./_model"

export const updateUserProfile = (data: UserUpdateRequest) => {
  return iAxios.patch(API_URLs.auth.profile, data)
  .then(r => r.data)
  .catch(e => e)
}